import { useForm } from 'react-hook-form';
import {login} from "../../api/customer";
import {useContext, useState} from "react";
import {ReducerStateInterface} from "../../interfaces/core/ReducerStateInterface";
import {GlobalContext} from "../../GlobalReducer";
import {useNavigate} from "react-router-dom";
import RemindPassword from "./RemindPassword";

interface AuthFormData {
    email: string;
    password: string;
}

export default function Auth({close}:{close: () => void}) {
    const { register, handleSubmit, formState: { errors } } = useForm<AuthFormData>();
    const [, dispatch] = useContext<[ReducerStateInterface, Function]>(GlobalContext);
    const [errorMessage, setErrorMessage] = useState<string>('');
    const [showRemindPassword, setShowRemindPassword] = useState<boolean>(false);

    const navigate = useNavigate();

    const onSubmit = async (data: AuthFormData) => {
        setErrorMessage('');
        try {
            const response = await login(data.email, data.password);
            if(response.manager){
                dispatch({ type: 'SET_MANAGER', payload: response });
            }else{
                dispatch({ type: 'SET_CUSTOMER', payload: response.customer });
            }
            close();
            navigate('/account/profile')
        } catch (error: any) {
            setErrorMessage(error.response?.data?.message || error.message || 'Ошибка авторизации');
        }
    };

    if (showRemindPassword) {
        return <RemindPassword close={close} onBack={() => setShowRemindPassword(false)} />;
    }

    return (<div className={"modal show"} onClick={close}>
        <div className="modal-dialog modal-dialog-centered" onClick={(e) => e.stopPropagation()}>
            <div className="d-flex flex-column modal-content">
                <div className="d-flex flex-column modal-box modal-header">
                    <button type="button" className="btn-close"
                            aria-label="Закрыть" onClick={close}></button>
                    <div className="fw-bold modal-title" id="modalVerticallyCenteredLabel">Авторизация</div>
                </div>
                <form onSubmit={handleSubmit(onSubmit)}>
                    {errorMessage && (
                        <div className="d-flex flex-column modal-box modal-body">
                            <div className="alert alert-danger" role="alert">
                                {errorMessage}
                            </div>
                        </div>
                    )}
                    <div className="d-flex flex-column modal-box modal-body">
                        <div className="form-control-item">
                            <input
                                type="email"
                                className={`form-control ${errors.email ? 'is-invalid' : ''}`}
                                placeholder="Электронная почта"
                                {...register('email', {
                                    required: 'Email обязателен',
                                    pattern: {
                                        value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                                        message: 'Некорректный email'
                                    }
                                })}
                            />
                            {errors.email && <div className="invalid-feedback">{errors.email.message}</div>}
                        </div>
                        <div className="form-control-item">
                            <input
                                type="password"
                                className={`form-control ${errors.password ? 'is-invalid' : ''}`}
                                placeholder="Пароль"
                                {...register('password', {
                                    required: 'Пароль обязателен'
                                })}
                            />
                            {errors.password && <div className="invalid-feedback">{errors.password.message}</div>}
                        </div>
                    </div>
                    <div className="d-flex flex-column modal-box mt-3">
                        <button type="submit" className="btn btn-primary modal-btn two">Войти</button>
                        <button type="button" className="btn btn-secondary two mt-2" onClick={() => setShowRemindPassword(true)}>
                            Забыли пароль?
                        </button>
                    </div>
                </form>
            </div>
        </div>
    </div>)
}
